// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monCompteContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
    padding: 20px;
    color: white;
    background-color: #0C0B20;
    font-family: Arial, sans-serif;
    min-height: 100vh;
  }

  .monCompteForm{
    width: 100%;
    max-width: 500px;
  }
  
  .monCompteHeader {
    display: flex;
    justify-content: end;
    align-items: center;
  }
  
  .monCompteHeader h1 {
    font-size: 24px;
    color: #A2C100;
  }
  
  .logoutButton {
    background: none;
    color: #A2C100;
    border: none;
    font-size: 16px;
    cursor: pointer;
  }
  
  .monCompteForm .fileUploadContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
    width: 100%;
  }
  
  .monCompteForm .fileCircle {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background-color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  
  .monCompteForm .filePlaceholder p {
    text-align: center;
    color: #A2C100;
    font-size: 12px;
    padding: 20px;
  }

  .monCompteForm .fileCircle label{
    width: 100%;
    height: 100%;
  }
  
  .monCompteForm .uploadedImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
  
  .monCompteForm .monCompteUserInfo {
    display: flex;
    flex-direction: column;
    gap: 16px;
    color: #C3D32C;
    text-align: left;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
  }

  .monCompteForm .monCompteUserInfo p:nth-child(2){
    text-align: left;
    color: white;
    margin-bottom: 20px;
  }
  
  .monCompteForm .inputGroup {
    display: flex;
    gap: 8px;
    margin-bottom: 0;
  }
  
  .monCompteForm .inputWithIcon {
    width: 100%;
    border-radius: 10px;
    border: none;
    color: white;
    font-size: 16px;
    margin-bottom: 8px;
  }
  
  .monCompteForm .saveButton {
    width: 100%;
    padding: 15px;
    background-color: #A2C100;
    color: white;
    border: none;
    border-radius: 30px;
    font-size: 16px;
    cursor: pointer;
    margin-bottom: 15px;
  }
  
  .deleteButton {
    width: 100%;
    padding: 15px;
    color: #ff5353;
    border: none;
    border-radius: 30px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 20px;
  }
  
  .monCompteLogout{
    display:flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: #ff5353;
    margin-top: 20px;
    margin-bottom: -20px;
    z-index: 2;
  }`, "",{"version":3,"sources":["webpack://./src/assets/Styles/MonCompte.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;IACjB,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,UAAU;EACZ","sourcesContent":[".monCompteContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n    padding: 20px;\r\n    color: white;\r\n    background-color: #0C0B20;\r\n    font-family: Arial, sans-serif;\r\n    min-height: 100vh;\r\n  }\r\n\r\n  .monCompteForm{\r\n    width: 100%;\r\n    max-width: 500px;\r\n  }\r\n  \r\n  .monCompteHeader {\r\n    display: flex;\r\n    justify-content: end;\r\n    align-items: center;\r\n  }\r\n  \r\n  .monCompteHeader h1 {\r\n    font-size: 24px;\r\n    color: #A2C100;\r\n  }\r\n  \r\n  .logoutButton {\r\n    background: none;\r\n    color: #A2C100;\r\n    border: none;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .monCompteForm .fileUploadContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 20px 0;\r\n    width: 100%;\r\n  }\r\n  \r\n  .monCompteForm .fileCircle {\r\n    width: 150px;\r\n    height: 150px;\r\n    border-radius: 50%;\r\n    background-color: #333;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .monCompteForm .filePlaceholder p {\r\n    text-align: center;\r\n    color: #A2C100;\r\n    font-size: 12px;\r\n    padding: 20px;\r\n  }\r\n\r\n  .monCompteForm .fileCircle label{\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  \r\n  .monCompteForm .uploadedImage {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    border-radius: 50%;\r\n  }\r\n  \r\n  .monCompteForm .monCompteUserInfo {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    color: #C3D32C;\r\n    text-align: left;\r\n    font-family: Lato;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: normal;\r\n    text-transform: uppercase;\r\n  }\r\n\r\n  .monCompteForm .monCompteUserInfo p:nth-child(2){\r\n    text-align: left;\r\n    color: white;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .monCompteForm .inputGroup {\r\n    display: flex;\r\n    gap: 8px;\r\n    margin-bottom: 0;\r\n  }\r\n  \r\n  .monCompteForm .inputWithIcon {\r\n    width: 100%;\r\n    border-radius: 10px;\r\n    border: none;\r\n    color: white;\r\n    font-size: 16px;\r\n    margin-bottom: 8px;\r\n  }\r\n  \r\n  .monCompteForm .saveButton {\r\n    width: 100%;\r\n    padding: 15px;\r\n    background-color: #A2C100;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 30px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .deleteButton {\r\n    width: 100%;\r\n    padding: 15px;\r\n    color: #ff5353;\r\n    border: none;\r\n    border-radius: 30px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  .monCompteLogout{\r\n    display:flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 8px;\r\n    color: #ff5353;\r\n    margin-top: 20px;\r\n    margin-bottom: -20px;\r\n    z-index: 2;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
